module.exports = ".hidden{display:none !important}\n"